import React from 'react'
import { useRef, useState } from "react";
import { connect } from 'react-redux';
import Slider from "react-slick";
import { setCurrentlyBlueprint, setTogglerBlueprints } from '../redux/propertiesDucks';

const settingsSlick = {
    dots: false,
    infinite: true,
    speed: 500,
    fade:false,
    slidesToShow: 1,
    slidesToScroll: 1
  };


const SliderComponent = ({files,type = 'images',dispatch}) => {

    const [positionSlider,setPositionSlider] = useState(1)

    const sliderRef = useRef()

    return (
        <div id="slider-section" className={"slider-" + (type) + (files.length === 0 ? 'd-none' : '')}>
            <span className={"conPag " + (type)}>{positionSlider} / {files.length}</span>
            <Slider afterChange={(e) => setPositionSlider(e+1) + (type === 'images' && dispatch(setCurrentlyBlueprint(e+1)))} ref={sliderRef} {...settingsSlick}>
                {files ?
                    files.map( (file, i) => (
                    <div class="col-12">
                        <div class="vista">
                            <div class=" text-start py-4 position-relative">
                                <h4 class="mb-0 mx-auto">{type === 'images' ? file.description : file.title}</h4>
                            </div>
                            <div  onClick={() => (type === 'images' && dispatch(setTogglerBlueprints()))} className="div-iframe cursor-pointer position-relative">
                                {type === 'images' && <img src={file.original} alt="" />}
                                {/* {(type === 'videos') && <iframe allowfullscreen src={file.player_url ? file.player_url + (file.provider === 'youtube' ? "?fs=1&autoplay=0&rel=0&showinfo=0&modestbranding=1" : ''): ''} frameborder="0" showinfo="0" rel="0"></iframe> } */}
                                {(type === 'videos') && <iframe allowfullscreen="1" src={file.player_url ? file.player_url + (file.provider === 'youtube' ? "?fs=1&autoplay=0&rel=0&showinfo=0&modestbranding=1" : ''): ''} frameborder="0" ></iframe> }
                                {(type === 'tours') &&  <iframe src={file ? file.player_url : ''}></iframe> }
                            </div>
                        </div>
                    </div>  
                    )): "" }
            </Slider>
            <div className={"arrows-left zindex-1"  + (files?.length === 1 || positionSlider === 1 ? ' d-none' : '')}>
                <div className="arrow" onClick={() => sliderRef.current.slickPrev()}> <i></i> <i></i></div>
            </div>
            <div className={"arrows-right zindex-1"  + (files?.length === 1 || positionSlider === files?.length ? ' d-none' : '')}>
                <div className="arrow" onClick={() => sliderRef.current.slickNext()}> <i></i> <i></i> </div>
            </div>
            {type === 'images' && <span onClick={() => dispatch(setTogglerBlueprints())} className="legend-fullscreen">Abrir galería de planos</span>}
        </div>
    )
}

export default connect(state => ({
}),null)(SliderComponent);